import React from 'react';
import { observer } from 'mobx-react';
import { MasterDataModule } from '@ibe/tupvid-components';
import BlankPageLayout from '../Layouts/BlankPageLayout';

const MasterData = observer((): JSX.Element => {
  return (
    <BlankPageLayout>
      <div className="chub">
        <MasterDataModule allowCopy />
      </div>
    </BlankPageLayout>
  );
});
export default MasterData;
